/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {UpdateEmailComponent as ɵa} from './lib/components/email/updateEmail/updateEmail.component';
export {MaterialModule as ɵb} from './lib/material.module';
export {AutoFocus as ɵd} from './lib/util/auto-focus.directive';
export {NoDblClickDirectiveMat as ɵc} from './lib/util/no-dbl-click-mat.directive';